import React from "react";
import {DataTableColumnProps, TableData} from "peggirkit";
import {IntlShape} from "react-intl";
import {JobOpeningInOverview} from "@/data/entities/jobOpening";
import {SetStateFn} from "@/utils/SetStateUtils";
import JobActivationToggle from "@widgets/jobOpenings/activation/JobActivationToggle";
import DateFormatter from "@widgets/employees/overview/table/columns/DateFormatter";

export const getJobOpeningsTableColumns = (
    intl: IntlShape,
    setTableData: SetStateFn<JobOpeningInOverview[]>,
): DataTableColumnProps<JobOpeningInOverview>[] => ([
    {
        id: "type",
        label: {
            displayName: intl.formatMessage({id: "jobTitle"}),
        },
        primary: true,
        formatter: type => intl.formatMessage({id: `jobTitle.${type}`})
    },
    {
        id: "activatedOn",
        label: {
            displayName: intl.formatMessage({id: "lastActivatedOn"}),
        },
        primary: false,
        align: "right",
        formatter: x => <DateFormatter date={x}/>
    },
    {
        id: "deactivatedOn",
        label: {
            displayName: intl.formatMessage({id: "lastDeactivatedOn"}),
        },
        primary: false,
        align: "right",
        formatter: x => <DateFormatter date={x}/>
    },
    {
        id: "active",
        label: {
            displayName: intl.formatMessage({id: "availability"}),
            hide: false,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, jobOpening: TableData<JobOpeningInOverview>) => (
            <JobActivationToggle
                jobOpening={jobOpening}
                setTableData={setTableData}
            />
        ),
    },
]);